import { useModal } from "@app/core";

import { useModalStore } from "@/store/modal.js";

export const useAlertModal = () => {
  const alertModal = useModal("alert-modal", false);
  const alertModalStore = useModalStore();

  const changeModalStatus = (status: boolean) => {
    alertModalStore.changeAlertModalStatus(status);
  };

  return { alertModal, changeModalStatus };
};
